// Generate affiliate-tagged shopping search links.
// TODO: replace `styleme-20` with your real Amazon Associates tag via env var.
const AMAZON_TAG = "styleme-20";

const clean = (s) => (s || "").toString().replace(/\s+/g, " ").trim().slice(0, 120);

export const amazonSearch = (query) => {
  const q = encodeURIComponent(clean(query));
  return `https://www.amazon.in/s?k=${q}&tag=${AMAZON_TAG}`;
};

export const nykaaSearch = (query) => {
  const q = encodeURIComponent(clean(query));
  return `https://www.nykaa.com/search/result/?q=${q}`;
};

export const myntraSearch = (query) => {
  const q = encodeURIComponent(clean(query));
  return `https://www.myntra.com/${q}`;
};

// Build full shopping list from a look's recommendations.
export const buildShoppingList = (look) => {
  const items = [];
  if (look?.outfit?.recommendation) {
    items.push({
      label: clean(look.outfit.recommendation),
      category: "Outfit",
      stores: [
        { name: "Myntra", url: myntraSearch(look.outfit.recommendation) },
        { name: "Amazon", url: amazonSearch(look.outfit.recommendation) },
      ],
    });
  }
  if (look?.makeup?.lips) {
    items.push({
      label: `Lip color · ${clean(look.makeup.lips)}`,
      category: "Makeup",
      stores: [
        { name: "Nykaa", url: nykaaSearch(`lipstick ${look.makeup.lips}`) },
        { name: "Amazon", url: amazonSearch(`lipstick ${look.makeup.lips}`) },
      ],
    });
  }
  if (look?.makeup?.eyes) {
    items.push({
      label: `Eye look · ${clean(look.makeup.eyes)}`,
      category: "Makeup",
      stores: [
        { name: "Nykaa", url: nykaaSearch(`eyeshadow palette ${look.makeup.eyes}`) },
        { name: "Amazon", url: amazonSearch(`eyeshadow palette ${look.makeup.eyes}`) },
      ],
    });
  }
  (look?.accessories || []).forEach((a) => {
    items.push({
      label: clean(a),
      category: "Accessory",
      stores: [
        { name: "Amazon", url: amazonSearch(a) },
        { name: "Myntra", url: myntraSearch(a) },
      ],
    });
  });
  return items;
};
